// import { useEffect, useState } from 'react'
// import { EMPTY_OBJECT, EMPTY_STRING } from './empty'
// // import { Alert, DeviceEventEmitter, Keyboard, Linking, Platform } from 'react-native'
// // import NetInfo from '@react-native-community/netinfo'
import _get from 'lodash/get'
import _times from 'lodash/times'
import _isNull from 'lodash/isNull'
import _isEmpty from 'lodash/isEmpty'
import _filter from 'lodash/filter'
import _isInteger from 'lodash/isInteger'
import { useCallback } from 'react';
// import {
//   DEVICE_IDENTIFIER_RECEIVED,
//   JOINED_TOURNAMENTS,
//   LOGIN_TYPES,
//   MAIN_CLIENT,
//   SERIAL_NUMBER_STORE_KEY,
//   MAX_ADJUST_ID_RETRY_COUNT,
//   LAST_REQUEST_HOME_PAGE_V3,
//   HOME_PAGE_WIDGETS_RESPONSE,
//   GAME_LIST,
//   UN_LOCKED_GAME_LIST,
//   ON_BOARDING_STEPS
// } from './constants'
// import { SET_ONBOARDING_COMPLETED } from 'utils/helpers/apiEndpoints'
// import { requestApiPost } from 'utils/helpers/ajax'
// import { readData, storeData, removeItem } from './asyncStorageUnsecure'
// import { s3_url, iosVersion, appVersion, appPackageName } from './environment'
// import { Adjust } from 'react-native-adjust'
// import DeviceInfo, { hasNotch } from 'react-native-device-info'
// import { CLEVERTAP_EVENTS, sendEvents } from 'src/analytics/eventWrapper'
// import CleverTap from 'clevertap-react-native'
// import translations from 'utils/helpers/localization'
// import store from 'store'

import { store } from "../../store"
import { getCurrentTimestamp, TIME_FORMAT_DAY_HOUR_MINUTE, TIME_FORMAT_HOUR_MINUTE } from "../DateUtils"
import { EMPTY_OBJECT, EMPTY_STRING } from "./empty"
import { getNetworkInfo } from '../NetInfo'
import { useTokenStore } from '../../storage/tokenState'
import { PARTNER_ID } from './constants'
import { PARTNER_ID_KEY } from '../../appConstants/AppConstant'

// import isUndefined from 'lodash/isUndefined'
// import { LANGUAGE } from './localization'
// import { IMAGE_PICKER_ERRORS, ULT } from 'screens/settings/constants'
// import { setSerialNumber } from 'store/actions/app'
// import { updateOnboardingCurrentStepsIndex, setOnBoardingCompleted } from 'store/actions/user'
// import _noop from 'lodash/noop'
// import moment from 'moment'
// import { getCurrentTimestamp, newDateFromTimestamp } from '../ZupeeClock'
// import logger, { TAG_NAMES } from 'utils/Logger'
// import { getToken } from 'utils/helpers/token'
// import _replace from 'lodash/replace'
// import dayjs from 'dayjs'
// import {
//   getUserOnboardingCompleted,
//   getOnboardingCurrentStepsIndex,
//   getOnboardingOriginalSteps,
//   getUserDataSignupPhoneNumber,
//   getUserDataGoogleToken }
// from 'store/selectors/user'
// import { TIME_FORMAT_DAY_HOUR_MINUTE, TIME_FORMAT_HOUR_MINUTE } from '../../utils/DateUtils'
// const { PHONE, GOOGLE, APPLE } = LOGIN_TYPES

// const ONE_HOUR = 60 * 60 * 1000
// const SEVEN_SECONDS = 7 * 1000
// const THIRTY_FIVE_SECONDS = 35 * 1000
// let fallbackSerialNumberTimeout = null

export const parseJSON = (jsonString, defaultVal = EMPTY_OBJECT) => {
  let result = defaultVal
  if (!jsonString) {
    return result
  }
  try {
    result = JSON.parse(jsonString)
  } catch (error) {
    // logger(TAG_NAMES.GENERIC, 'UNABLE TO parseJSON', {
    //   isBreadcrumb: true,
    //   isLogToFile: true,
    //   error
    // })
  }
  return result
}

export const parseString = jsonObject => {
  let result = EMPTY_STRING
  try {
    result = JSON.stringify(jsonObject)
  } catch (error) {
    // logger(TAG_NAMES.GENERIC, 'UNABLE TO STRINGIFY', {
    //   isAddEvent: true,
    //   isBreadcrumb: true,
    //   isLogToFile: true,
    //   error
    // })
  }
  return result
}

// export const ALPHA_NUMERIC_CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

// export const generateRandomString = strLength => {
//   let result = ''
//   const charactersLength = ALPHA_NUMERIC_CHARACTERS.length
//   _times(strLength, () => {
//     result += ALPHA_NUMERIC_CHARACTERS.charAt(Math.floor(Math.random() * charactersLength))
//   })

//   return result
// }

// export const getSerialNumber = async () => {
//   const serialNumber = await readData(SERIAL_NUMBER_STORE_KEY)
//   return serialNumber
// }

// export const saveSerialNumber = serialNumber => {
//   storeData(SERIAL_NUMBER_STORE_KEY, serialNumber)
// }
const readData = (key) => localStorage.getItem(key);
export const getToken = () => {
  const tokenString = readData('USER_TOKEN');
  if (_isEmpty(tokenString)) {
    // logger(TAG_NAMES.GENERIC, 'USER_TOKEN', {
    //   isAddEvent: true,
    //   isLogToFile: false,
    //   data: {
    //     message: 'Empty USER_TOKEN from localStorage',
    //     location: 'utils/token.js'
    //   }
    // });
    // return Promise.resolve({});
    return {}
  }
  // return Promise.resolve(parseJSON(tokenString));
  return parseJSON(tokenString);
};

export const getPostSignupConfig = () => {
  const signupString = readData('USER_PRESIGNUP');
  if (_isEmpty(signupString)) {
    return {}
  }
  return parseJSON(signupString);
};

export const iosVersion = '6059'
export const appVersion = 'IOS_2.2412.01_GOLD'
export const appPackageName = 'in.ludo.supremegold'
export const appPackageNameIos = 'in.ios.ludosupremegold'
export const s3_url = 'https://ludo-upload-bucket.s3.ap-south-1.amazonaws.com'

export async function getGameplaySpEventData(params) {
  const { new_login = false, number, otp, SOCKETTYPE="GAMEPLAY_CLIENT" } = params || {};
  const postConfigData = getPostSignupConfig();
  const { postSignupConfig } = postConfigData?.state || {};
  const token = getToken();
  const userToken = token?.state?.token || {}
  const deviceId = readData('deviceID');

  const { accessToken,unique_id, signupPhoneNumber = '', refreshToken, ue, un, ult = 'phone', refreshTokenExpiresAt=0, _id, zupeeUserId, lastAccessToken } = userToken;
  const {manageMainSocketInBackground} = postSignupConfig || {};
  const osVersion = getOSVersion();
  const deviceSpec = getDeviceSpec();
  const formattedTimestamp = getFormattedTimestamp();
  const netInfo = getNetworkInfo();
  const { isConnected, effectiveType } = netInfo;

  const data = {
    socketType: SOCKETTYPE,
    rfc: '',
    packageName:  `${process.env.REACT_APP_APP_NAME}`,
    det: 'android',
    deviceType: 'android',
    lc: localStorage.getItem("language") || "en",
    languagePreference: localStorage.getItem("language") || "en",
    DeviceId: deviceId || '',
    ue:"",
    un,
    signupPhoneNumber,
    ult:"phone",
    reauth: true,
    lastAccessToken: lastAccessToken || accessToken,
    refreshToken: refreshToken || '',
    uniqueDeviceId: deviceId || unique_id,
    SerialNumber: deviceId,
    av: `${process.env.REACT_APP_VERSION}`,
    // iv: iosVersion,
    app_version: `${process.env.REACT_APP_APPVERSION}`,
    version_code: `${process.env.REACT_APP_VERSION}`,
    anov: osVersion,
    connectionInfo: JSON.stringify({ 
      isConnected: isConnected,
      networkType: effectiveType
    }),
    is_pwa:true,
    uid: _id,
    merchantName: "SUPER_ZUPEE",
    zupeeUserId,
    specs: deviceSpec,
    isNewSignupFlowEnabled: true,
    timeStamp: formattedTimestamp,
    "user-property": "00000",
  }

  switch (SOCKETTYPE){
    case "GAMEPLAY_CLIENT": {
      return {
        ...data,
        oldMainSocketIds: []
      }
    }
    default: {
      const { reauth, lastAccessToken, deviceType, un,  ...defaultData } = data;
      return {
        ...defaultData,
        ...(new_login ? { newauth: true, otp, action: "SignUp"} : {reauth: true, lastAccessToken}),
        accessToken: accessToken,
        manageMainSocketInBackground,
        authenticateWithRestApi: true,
        gaId: deviceId,
        
        // isUsbDebuggingEnabled: true,
        refreshTokenExpiresAt,
        isNewSignup: false,
        source: "",
        medium: "",
        campaign: "",
        ...(sessionStorage.getItem("ppEnabled") && {
          'x-zupee-env': 'pre-prod',
          'x-zupee-pp-token': sessionStorage.getItem("googleToken") || "",
        })
      }
    }
  } 
}

// export const getSpEventData = async (params = EMPTY_OBJECT) => {
//   const {
//     pp,
//     un,
//     otp,
//     email,
//     action,
//     loginType,
//     token = {},
//     appleToken,
//     number = '',
//     googleToken,
//     socketType = MAIN_CLIENT
//   } = params
//   const language = translations.getLanguage()

//   let data = {
//     socketType,
//     action,
//     rfc: '',
//     av: iosVersion,
//     iv: iosVersion,
//     app_version: appVersion, // MAJOR_VERSION.YYMM.NUMBER_OF_BUILD
//     version_code: iosVersion,
//     packageName: appPackageName,
//     anov: Platform.Version,
//     det: 'ios',
//     deviceType: 'ios',
//     lc: language,
//     languagePreference: language,
//     DeviceId: ''
//   }

//   const serialNumber = await getSerialNumberPromiseFromStore()

//   switch (loginType) {
//     case PHONE:
//       data.signupPhoneNumber = number
//       data.ult = PHONE
//       data = { ...data, newauth: true, otp }
//       break

//     // case GOOGLE:
//     //   data.ult = GOOGLE
//     //   data = { ...data, newauth: true, ppv1: pp, pp, ue: email, googleToken, un }
//     //   break

//     // case APPLE:
//     //   data.ult = APPLE
//     //   data = { ...data, newauth: true, ue: email, appleToken, un }
//     //   break

//     default: {
//       const { accessToken, signupPhoneNumber = '', refreshToken, ue, un, ult, googleToken } = token
//       // if (ult === ULT.GOOGLE) {
//       //   data.googleToken = googleToken
//       // }

//       data = {
//         ...data,
//         ue,
//         un,
//         signupPhoneNumber,
//         ult,
//         reauth: true,
//         lastAccessToken: accessToken,
//         refreshToken: refreshToken || ''
//       }
//       break
//     }
//   }

//   const netInfo = await getNetworkInfo.fetch()

//   const spEventData = {
//     ...data,
//     uniqueDeviceId: serialNumber,
//     SerialNumber: serialNumber,
//     connectionInfo: JSON.stringify({ networkType: netInfo.type, isConnected: true })
//   }

//   // logger(TAG_NAMES.GENERIC, 'Sp Event Data', { isLogDataToFile: true, isBreadcrumb: true, data: spEventData })

//   return spEventData
// }
// export const isTrackingTurnedOffIos = idfa => {
//   return idfa === '00000000-0000-0000-0000-000000000000'
// }
// export const uuidv4 = () => {
//   return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
//     // eslint-disable-next-line no-bitwise
//     var r = (Math.random() * 16) | 0,
//       // eslint-disable-next-line no-bitwise
//       v = c === 'x' ? r : (r & 0x3) | 0x8
//     return v.toString(16)
//   })
// }

export const getSerialNumberPromiseFromStore = async () => {
  const state = store.getState()
  return _get(state, 'app.serialNumber')
}

// const getAdjustId = (resolve, retryCount = 0) => {
//   Adjust.getAdid(async adid => {
//     if (retryCount > MAX_ADJUST_ID_RETRY_COUNT) {
//       //We'll try 5 times to get the adid
//       return
//     }
//     if (!_isEmpty(adid)) {
//       resolve(adid)
//       logDeviceIdOnSentry(adid)
//       logger(TAG_NAMES.GENERIC, 'getAdjustId, adid', {
//         isBreadcrumb: true,
//         isLogToFile: false,
//         data: { adid }
//       })
//       DeviceEventEmitter.emit(DEVICE_IDENTIFIER_RECEIVED, adid)
//       return
//     } else {
//       logger(TAG_NAMES.GENERIC, 'getAdjustId, adid not found', {
//         isBreadcrumb: true,
//         isLogToFile: false,
//         data: { retryCount }
//       })
//       await new Promise((resolveTimeout, reject) => setTimeout(resolveTimeout, 500))
//       getAdjustId(resolve, retryCount + 1)
//     }
//   })
// }

// // export const setSerialNumberPromiseToStore = () => {
// //   updateSerialNumber().then(serialNumber => {
// //     store.dispatch(setSerialNumber(serialNumber))
// //     clearTimeout(fallbackSerialNumberTimeout)
// //     logger(TAG_NAMES.GENERIC, 'Clean fallbackSerialNumberTimeout on updateSerialNumber')
// //   })
// // }

// // export const setSerialNumberPromiseToStoreFromDeviceInfo = serialNumber => {
// //   store.dispatch(setSerialNumber(serialNumber))
// // }

// // function getUniqueDeviceIdentifierFallbackCase(resolve) {
// //   clearTimeout(fallbackSerialNumberTimeout)
// //   fallbackSerialNumberTimeout = setTimeout(() => {
// //     const uniqueId = DeviceInfo.getUniqueId()
// //     logger(TAG_NAMES.GENERIC, 'Device Identifier not Received after 3000ms', {
// //       isBreadcrumb: true,
// //       isLogToFile: false,
// //       data: { uniqueId }
// //     })

// //     if (!_isEmpty(uniqueId)) {
// //       resolve(uniqueId)
// //       DeviceEventEmitter.emit(DEVICE_IDENTIFIER_RECEIVED, uniqueId)
// //     }
// //   }, 3000)
// // }

// // export const updateSerialNumber = async () => {
// //   try {
// //     const promise = new Promise(async (resolve, reject) => {
// //       const majorVersionIOS = parseInt(Platform.Version, 10)
// //       if (majorVersionIOS >= 14) {
// //         Adjust.requestTrackingAuthorizationWithCompletionHandler(function (status) {
// //           getUniqueDeviceIdentifierFallbackCase(resolve)
// //           switch (status) {
// //             case 3:
// //               Adjust.getIdfa(idfa => {
// //                 sendEvents({ name: CLEVERTAP_EVENTS.EVENT_IDFA_TRACKING_ALLOWED })
// //                 logDeviceIdOnSentry(idfa)
// //                 DeviceEventEmitter.emit(DEVICE_IDENTIFIER_RECEIVED, idfa)
// //                 resolve(idfa)
// //               })
// //               break
// //             default:
// //               logger(TAG_NAMES.GENERIC, 'Adjust.requestTrackingAuthorizationWithCompletionHandler', {
// //                 isBreadcrumb: true,
// //                 isLogToFile: false,
// //                 data: { status }
// //               })
// //               sendEvents({ name: CLEVERTAP_EVENTS.EVENT_IDFA_TRACKING_NOT_ALLOWED })
// //               getAdjustId(resolve)
// //           }
// //           CleverTap.registerForPush()
// //         })
// //       } else {
// //         getUniqueDeviceIdentifierFallbackCase(resolve)
// //         CleverTap.registerForPush()
// //         const serialNumber = await getSerialNumber()
// //         if (!isStringEmptyOrNull(serialNumber)) {
// //           logger(TAG_NAMES.GENERIC, 'serialNumber already exists', {
// //             isBreadcrumb: true,
// //             isLogToFile: false,
// //             data: { serialNumber }
// //           })
// //           DeviceEventEmitter.emit(DEVICE_IDENTIFIER_RECEIVED, serialNumber)
// //           resolve(serialNumber)
// //           logDeviceIdOnSentry(serialNumber)
// //           sendEvents({ name: CLEVERTAP_EVENTS.EVENT_DEVICE_ID_PICKED_FROM_ASYNC_STORAGE })
// //           return
// //         }
// //         Adjust.getIdfa(idfa => {
// //           if (isTrackingTurnedOffIos(idfa)) {
// //             sendEvents({ name: CLEVERTAP_EVENTS.EVENT_IDFA_TRACKING_NOT_ALLOWED })
// //             logger(TAG_NAMES.GENERIC, 'isTrackingTurnedOffIos', {
// //               isBreadcrumb: true,
// //               isLogToFile: false,
// //               data: { idfa }
// //             })
// //             getAdjustId(resolve)
// //           } else {
// //             sendEvents({ name: CLEVERTAP_EVENTS.EVENT_IDFA_TRACKING_ALLOWED })
// //             logger(TAG_NAMES.GENERIC, 'Idfa Tracking Turned on', {
// //               isBreadcrumb: true,
// //               isLogToFile: false,
// //               data: { idfa }
// //             })
// //             DeviceEventEmitter.emit(DEVICE_IDENTIFIER_RECEIVED, idfa)
// //             resolve(idfa)
// //             logDeviceIdOnSentry(idfa)
// //             saveSerialNumber(idfa)
// //           }
// //         })
// //       }
// //     })
// //     return promise
// //   } catch (error) {
// //     logger(TAG_NAMES.GENERIC, 'updateSerialNumber', {
// //       isAddEvent: true,
// //       isLogToFile: false,
// //       error
// //     })
// //   }
// // }
// export const getQueryStringFromParams = (params = EMPTY_OBJECT) => new URLSearchParams(params).toString()

// const getS3Ulr = subUrl => `${s3_url}/${subUrl}`

// export const logDeviceIdOnSentry = deviceId => {
//   if (isStringEmptyOrNull(deviceId) || isTrackingTurnedOffIos(deviceId)) {
//     logger(TAG_NAMES.GENERIC, `Invalid DeviceId:${deviceId}`, {
//       isAddEvent: true,
//       isLogToFile: false
//     })
//   }
// }

// export const isStringEmptyOrNull = string => {
//   if (string === null || string === undefined || string === EMPTY_STRING) {
//     return true
//   }
//   return false
// }

// const convertToRupees = (x = 0, toFixedPoint = 2, showPlusSign) => {
//   if (_isNull(x) || isUndefined(x)) {
//     x = 0
//   }
//   let _sign = ''
//   if (x < 0) {
//     x = Math.abs(x)
//     _sign = '- '
//   } else if (x > 0 && showPlusSign) {
//     _sign = '+ '
//   }

//   let derivedToFixedPoint = Number.isInteger(x) ? 0 : toFixedPoint
//   let rupees = derivedToFixedPoint ? Number(x).toFixed(derivedToFixedPoint) : Math.floor(Number(x))
//   return `${_sign}₹${rupees.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
// }

// export const formatNumber = (x = 0, toFixedPoint = 2, showPlusSign = false) => {
//   if (_isNull(x) || isUndefined(x)) {
//     x = 0
//   }

//   let sign = ''
//   if (x < 0) {
//     x = Math.abs(x)
//     sign = '- '
//   } else if (x > 0 && showPlusSign) {
//     sign = '+ '
//   }

//   let derivedToFixedPoint = Number.isInteger(x) ? 0 : toFixedPoint
//   let formattedNumber = derivedToFixedPoint ? Number(x).toFixed(derivedToFixedPoint) : Math.floor(Number(x))
//   return `${sign}${formattedNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
// }

// const RUPEE_CHARACTER = '₹'

// // const useKeyboardToggle = () => {
// //   const [keyboardHeight, setKeyboardHeight] = useState(0)
// //   useEffect(() => {
// //     const keyboardWillShow = Platform.select({ ios: 'keyboardWillShow', android: 'keyboardDidShow' })
// //     const keyboardWillHide = Platform.select({ ios: 'keyboardWillHide', android: 'keyboardDidHide' })

// //     const didShowListener = Keyboard.addListener(keyboardWillShow, ({ endCoordinates }) => {
// //       setKeyboardHeight(endCoordinates.height)
// //     })
// //     const didHideListener = Keyboard.addListener(keyboardWillHide, () => {
// //       setKeyboardHeight(0)
// //     })

// //     return () => {
// //       didHideListener.remove()
// //       didShowListener.remove()
// //     }
// //   }, [])

// //   if (hasNotch() && keyboardHeight > 0) {
// //     return keyboardHeight - 35
// //   }
// //   return keyboardHeight
// // }
// var isValidCard = cardNo => {
//   let s = 0
//   let doubleDigit = false
//   for (let i = cardNo.length - 1; i >= 0; i--) {
//     var digit = +cardNo[i]
//     if (doubleDigit) {
//       digit *= 2
//       if (digit > 9) {
//         digit -= 9
//       }
//     }
//     s += digit
//     doubleDigit = !doubleDigit
//   }
//   return s % 10 === 0
// }
// const getAppLanguage = async () => {
//   const language = await readData(LANGUAGE)
//   return language
// }

// export const readJoinedTournaments = async () => {
//   let joinedTournaments = parseJSON(await readData(JOINED_TOURNAMENTS))
//   if (_isEmpty(joinedTournaments)) {
//     joinedTournaments = []
//   }
//   // we will consider only those tournaments which were registered in last one hour
//   const currentTime = getCurrentTimestamp()
//   const joinedInLastHour = _filter(joinedTournaments, ({ timestamp }) => timestamp > currentTime - ONE_HOUR)

//   return joinedInLastHour
// }

// export const readJoinableTournaments = async () => {
//   let joinedTournaments = parseJSON(await readData(JOINED_TOURNAMENTS))
//   if (_isEmpty(joinedTournaments)) {
//     joinedTournaments = []
//   }
//   // we will only check for tournaments for which currentTime is greater than startTime - 7 secs and
//   // less than startTime + 35 secs
//   const currentTime = getCurrentTimestamp()

//   const joinableTournaments = _filter(
//     joinedTournaments,
//     ({ startTime }) => startTime - SEVEN_SECONDS < currentTime && startTime + THIRTY_FIVE_SECONDS > currentTime
//   )

//   return joinableTournaments
// }

// export const saveJoinedTournaments = async data => {
//   const prevJoined = await readJoinedTournaments()
//   const updatedJoined = [...prevJoined, { ...data, timestamp: getCurrentTimestamp() }]
//   await storeData(JOINED_TOURNAMENTS, updatedJoined)
// }

// export const removeJoinedTournaments = async ltid => {
//   const joinedTournaments = await readJoinedTournaments()
//   const updatedJoined = _filter(joinedTournaments, tournament => tournament.ltid !== ltid)
//   await storeData(JOINED_TOURNAMENTS, updatedJoined)
// }

// const delayBy = (milliSeconds = 1000) =>
//   new Promise((res, rej) => {
//     const timeOutRef = setTimeout(() => {
//       clearTimeout(timeOutRef)
//       res()
//     }, milliSeconds)
//   })

// // const systemALert = (
// //   heading = translations.settings,
// //   subHeading = 'Please give permission',
// //   cancelText = translations.cancel,
// //   cancelAction = _noop,
// //   okText = translations.ok,
// //   okAction = () => {
// //     Linking.openSettings()
// //   }
// // ) => {
// //   Alert.alert(heading, subHeading, [
// //     {
// //       text: cancelText,
// //       onPress: cancelAction,
// //       style: 'destructive'
// //     },
// //     { text: okText, onPress: okAction }
// //   ])
// // }

// // const handleImagePickerCatch = (e, location) => {
// //   switch (e?.code) {
// //     case IMAGE_PICKER_ERRORS.E_PICKER_CANCELLED: {
// //       break
// //     }
// //     case IMAGE_PICKER_ERRORS.E_NO_CAMERA_PERMISSION: {
// //       systemALert(translations.settings, translations.cameraPermission, translations.cancel, _noop, translations.ok)
// //       break
// //     }
// //     case IMAGE_PICKER_ERRORS.E_NO_LIBRARY_PERMISSION_SHARE:
// //     case IMAGE_PICKER_ERRORS.E_NO_LIBRARY_PERMISSION: {
// //       systemALert(translations.settings, translations.photosPermission, translations.cancel, _noop, translations.ok)
// //       break
// //     }
// //     default: {
// //       logger(TAG_NAMES.GENERIC, `Image Picker Catch:${location}`, {
// //         isAddEvent: true,
// //         isLogToFile: false,
// //         error: e
// //       })
// //       break
// //     }
// //   }
// // }

// const getDateFromTimestamp = timestamp => {
//   try {
//     const newDate = new Date(timestamp)?.toLocaleDateString('en-GB', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       timeZone: 'IST'
//     })
//     if (!newDate) {
//       return newDateFromTimestamp()
//     }
//     return newDate
//   } catch(error) {
//     logger(TAG_NAMES.GENERIC, `Failed to get date from tmestamp`, {
//       isAddEvent: true,
//       isLogToFile: false,
//       error: error
//     })
//     return new Date()?.toLocaleDateString('en-GB', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       timeZone: 'IST'
//     })
//   }
// }

// const getDateOnlyFromTimestamp = timestamp => {
//   try {
//     const newDate = new Date(timestamp)?.toLocaleDateString('en-GB', {
//       month: 'short',
//       day: 'numeric',
//       timeZone: 'IST'
//     })
//     if (!newDate) {
//       return newDateFromTimestamp()
//     }
//     return newDate
//   } catch(error) {
//     logger(TAG_NAMES.GENERIC, `Failed to get date from tmestamp`, {
//       isAddEvent: true,
//       isLogToFile: false,
//       error: error
//     })
//     return new Date()?.toLocaleDateString('en-GB', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       timeZone: 'IST'
//     })
//   }
// }

// const getTimeStamp = (complexDate, timeComponents = '0:0:0') => {
//   const newDate = new Date(complexDate)

//   const [day, month, year] = [newDate.getDate(), newDate.getMonth(), newDate.getFullYear()]
//   const [hours, minutes, seconds] = timeComponents.split(':')

//   const date = new Date(+year, month, +day, +hours, +minutes, +seconds) //  Sat Apr 16 2022 06:45:12

//   return date.getTime()
// }

// const getCurrentIndianIsoDate = () => {
//   return moment(newDateFromTimestamp())
// }

// const getCircularReplacer = () => {
//   const seen = new WeakSet()
//   return (key, value) => {
//     if (typeof value === 'object' && value !== null) {
//       if (seen.has(value)) {
//         return
//       }
//       seen.add(value)
//     }
//     return value
//   }
// }

// const getEntryFeeSplit = (entryFee, playerCount, prizePot = null) => {
//   const totalContribution = playerCount * entryFee
//   const platformFee = (totalContribution - prizePot) / playerCount
//   const playerShare = entryFee - platformFee
//   return {
//     platformFee: _isInteger(platformFee) ? platformFee.toFixed(0) : platformFee.toFixed(2),
//     playerShare: _isInteger(playerShare) ? playerShare.toFixed(0) : playerShare.toFixed(2)
//   }
// }

// const queuedRequests = {}

// const getMemoryUsage = function (onLaunchMemory, sourceLocation, ramConfig) {
//   if (!ramConfig?.enabled) {
//     return
//   }
//   const currentMemoryUsage = DeviceInfo.getUsedMemorySync() / 1048576
//   return {
//     message: `[${sourceLocation}]:: Current Memory : ${parseInt(currentMemoryUsage)}Mib, onLaunchMemory : ${parseInt(
//       onLaunchMemory
//     )}Mib`,
//     shouldSendError: ramConfig?.thresholdInMiB < currentMemoryUsage - onLaunchMemory,
//     currentMemoryUsage: parseInt(currentMemoryUsage)
//   }
// }

// const convertMillisecondsToTime = milliseconds => {
//   // Convert milliseconds to seconds
//   let seconds = Math.floor(milliseconds / 1000)

//   // Calculate days, hours, minutes, and remaining seconds
//   const days = Math.floor(seconds / 86400) // 86400 seconds in a day
//   seconds %= 86400
//   const hours = Math.floor(seconds / 3600) // 3600 seconds in an hour
//   seconds %= 3600
//   const minutes = Math.floor(seconds / 60) // 60 seconds in a minute
//   seconds %= 60

//   return {
//     days: days,
//     hours: hours,
//     minutes: minutes,
//     seconds: seconds
//   }
// }

// const convertEpochTo12HrClock = epochTimestamp => {
//   const date = new Date(epochTimestamp)

//   const hours = date.getHours()
//   const minutes = date.getMinutes()

//   const meridiem = hours >= 12 ? 'PM' : 'AM'

//   // Convert hours to 12-hour clock format
//   let hours12 = hours % 12
//   hours12 = hours12 === 0 ? 12 : hours12 // Handle midnight (12 AM)

//   return `${hours12.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${meridiem}`

// }

// const getInsertedText = (text, replaceBy) => {
//   const patternToReplace = '*!*'
//   return _replace(text, patternToReplace, replaceBy)
// }

// const objectToQueryString = obj => {
//   const keys = Object.keys(obj)
//   const keyValuePairs = keys.map(key => {
//     return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])
//   })
//   return keyValuePairs.join('&')
// }

// const clearHomePageResponseFromStore = async () => {
//   await removeItem(LAST_REQUEST_HOME_PAGE_V3)
//   await removeItem(HOME_PAGE_WIDGETS_RESPONSE)
//   await removeItem(GAME_LIST)
//   await removeItem(UN_LOCKED_GAME_LIST)
// }

// const convertEpochToDateMonthTimeFormat = timestamp => {
//   return dayjs(timestamp).format('DD MMM').toString() + ', ' + dayjs(timestamp).format('H:mm')
// }

// const handleOnBoardingCompleted = async(signupPhoneNumber, googleToken) => {
//   const res = await requestApiPost(SET_ONBOARDING_COMPLETED)
//   if(res?.data?.response?.success) {
//     store.dispatch(setOnBoardingCompleted())

//     sendEvents({
//       name: CLEVERTAP_EVENTS.EVENT_APP_ONBOARDING_COMPLETE,
//       params: {
//         user: signupPhoneNumber || googleToken
//       }
//     })
//     logger(TAG_NAMES.APP_ACTION, `Onboarding Completed API success`)
//   } else {
//     logger(TAG_NAMES.APP_ACTION, 'Onboarding Completed API failed', {
//       isAddEvent: false,
//       isLogToFile: false,
//       isBreadcrumb: true
//     })
//   }
// }

// const setOnBoardingCurrentStepIndex = async () => {
//   const state = store.getState()
//   const originalSteps = getOnboardingOriginalSteps(state)
//   const currentStepsIndex = getOnboardingCurrentStepsIndex(state)
//   const signupPhoneNumber = getUserDataSignupPhoneNumber(state)
//   const googleToken = getUserDataGoogleToken(state)
//   const onboardingCompleted = getUserOnboardingCompleted(state)

//   if(onboardingCompleted) return

//   const originalStepsLength = originalSteps.length

//   // Aim is to find current step.
//   // If originalStepsLength > 0, then find the next step from originalSteps
//   // If originalSteps is empty then redirect to dashboard (default)
//   // If currentStepsIndex has reached its max length then call setOnboarding API
//   if(originalStepsLength <= 0) {
//     store.dispatch(updateOnboardingCurrentStepsIndex(0))
//     return
//   }

//   if (currentStepsIndex >= originalStepsLength) {
//     // set onboarding API call
//     await handleOnBoardingCompleted(signupPhoneNumber, googleToken)
//   } else {
//     let nextOnboardingStepIndex = currentStepsIndex + 1

//     // This is to ensure to skip referral step even if BE sends it
//     // Since it has been removed from the onBoarding Journey
//     if(originalSteps[nextOnboardingStepIndex] === ON_BOARDING_STEPS.REFERRAL) {
//       nextOnboardingStepIndex++
//     }

//     store.dispatch(updateOnboardingCurrentStepsIndex(nextOnboardingStepIndex))

//     if (nextOnboardingStepIndex >= originalStepsLength) {
//       // set onboarding API call
//       await handleOnBoardingCompleted(signupPhoneNumber, googleToken)
//     }
//   }
// }


const isSameDay = timeStamp => {
  const currentTimestamp = getCurrentTimestamp()

  const currentDate = new Date(currentTimestamp)
  const givenDate = new Date(timeStamp)

  return currentDate.toDateString() === givenDate.toDateString()
}

export const getResultOutTimeFormat = timestamp => {
  if (isSameDay(timestamp)) {
    return TIME_FORMAT_HOUR_MINUTE
  }
  return TIME_FORMAT_DAY_HOUR_MINUTE
}

export const getPartnerId = () => {
  const partnerId = localStorage.getItem(PARTNER_ID_KEY) || PARTNER_ID;
  return partnerId;
}

export const getPageName = () => {
  if (typeof window !== "undefined") {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    return pathSegments[0] || 'home';
  }
  return "";
}

export function getDeviceSpec() {
  const osVersion = getOSVersion();
  const processorSpec = getProcessorSpec();
  const webVersion = getWebVersion();
  
  const specString = `${osVersion}|${processorSpec}|${webVersion}`;
  return btoa(specString).trim();
}

export function getOSVersion() {
  try {
    const userAgent = navigator.userAgent;
    let osVersion = '';

    if (/Windows NT/.test(userAgent)) {
      const match = userAgent.match(/Windows NT (\d+\.\d+)/);
      osVersion = match?.[1] || "10.0";
    } else if (/Mac OS X/.test(userAgent)) {
      const match = userAgent.match(/Mac OS X (\d+[._]\d+([._]\d+)?)/);
      osVersion = match?.[1]?.replace(/_/g, '.') || "10.15";
    } else if (/Android/.test(userAgent)) {
      const match = userAgent.match(/Android (\d+(\.\d+)?)/);
      osVersion = match?.[1] || "10";
    } else if (/iPhone|iPad/.test(userAgent)) {
      const match = userAgent.match(/OS (\d+[._]\d+([._]\d+)?)/);
      osVersion = match?.[1]?.replace(/_/g, '.') || "14.0";
    } else if (/Linux/.test(userAgent)) {
      osVersion = "Linux";
    } else {
      osVersion = "14.0"; // Default fallback version
    }

    return osVersion;
  } catch (error) {
    console.warn('Error getting OS version:', error);
    return "14.0"; // Default fallback version
  }
}

export function getProcessorSpec() {
  const platform = navigator.platform;
  const userAgent = navigator.userAgent;

  if (/arm64|aarch64/.test(platform) || /arm64/.test(userAgent)) {
    return "64-bit";
  } else if (/armv7|i686/.test(platform) || /armv7/.test(userAgent)) {
    return "32-bit";
  } else {
    return "Unknown";
  }
}

export function getWebVersion() {
  const userAgent = navigator.userAgent;
  const browserVersion = userAgent.match(/(Chrome|Firefox|Safari|Edge)\/(\d+\.\d+)/);
  return browserVersion ? browserVersion[2] : "Unknown";
}

export const getFormattedTimestamp = () => {
  return new Date().toLocaleString('en-US', { 
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'Asia/Kolkata'
  }).replace(',', '');
};


// export {
//   delayBy,
//   getS3Ulr,
//   isValidCard,
//   queuedRequests,
//   getMemoryUsage,
//   convertToRupees,
//   // useKeyboardToggle,
//   getAppLanguage,
//   // systemALert,
//   // handleImagePickerCatch,
//   getDateFromTimestamp,
//   getTimeStamp,
//   RUPEE_CHARACTER,
//   getCircularReplacer,
//   getEntryFeeSplit,
//   getCurrentIndianIsoDate,
//   convertMillisecondsToTime,
//   objectToQueryString,
//   clearHomePageResponseFromStore,
//   convertEpochTo12HrClock,
//   getInsertedText,
//   convertEpochToDateMonthTimeFormat,
//   setOnBoardingCurrentStepIndex,
//   getDateOnlyFromTimestamp,
//   isSameDay,
//   getResultOutTimeFormat
// }
